import { useCallback, useEffect } from 'react'
import { useAppDispatch, useAppSelector } from '@libs/redux/hooks'

import { appSlice } from '@libs/redux/app/app.slice'

interface Size {
  width: number | undefined
  height: number | undefined
}

const TABLET_MAX_WIDTH = 1250

export const useWindowSize = (): {
  windowSize: Size
  isMobile: boolean
} => {
  const dispatch = useAppDispatch()

  const windowSize = useAppSelector((state) => state.app.windowSize)

  const setWindowSize = useCallback(
    (size: Size) => {
      dispatch(appSlice.actions.setWindowSize({ size }))
    },
    [dispatch],
  )

  const isMobile = windowSize.width != undefined && windowSize.width <= TABLET_MAX_WIDTH

  useEffect(() => {
    function handleResize() {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      })
    }

    window.addEventListener('resize', handleResize)

    handleResize()

    return () => window.removeEventListener('resize', handleResize)
  }, [setWindowSize])

  return { windowSize, isMobile }
}
